var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_4634_269_00000106149309773048525750000009067070618293152391_);}\r\n\t.st2{fill:#15B79E;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 1.9,
    y: 2,
    width: 20.2,
    height: 20
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.9,
    y: 2,
    width: 20.2,
    height: 20,
    id: "mask0_4634_269_00000106149309773048525750000009067070618293152391_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12,22c-2,0-3.9-0.5-5.5-1.6c-1.6-1.1-2.8-2.5-3.6-4.4v3.3h-1v-5h5v1H3.7c0.6,1.7,1.7,3.1,3.2,4.1 c1.5,1,3.2,1.6,5.1,1.6c1.2,0,2.3-0.2,3.4-0.6c1.1-0.4,2-1,2.8-1.8c0.8-0.8,1.5-1.7,2-2.7c0.5-1,0.8-2.2,0.9-3.4h1 c-0.1,1.3-0.4,2.6-0.9,3.7c-0.5,1.2-1.3,2.2-2.2,3c-0.9,0.9-1.9,1.5-3.1,2C14.6,21.8,13.3,22,12,22z M11.5,18.6v-1.2 c-0.7-0.2-1.3-0.4-1.7-0.8c-0.5-0.4-0.9-0.9-1.1-1.6l0.9-0.4c0.3,0.6,0.6,1.1,1.1,1.4c0.5,0.3,1,0.5,1.6,0.5c0.6,0,1.1-0.2,1.7-0.5 c0.5-0.3,0.8-0.8,0.8-1.5c0-0.6-0.2-1-0.6-1.3c-0.4-0.3-1.1-0.7-2.2-1.1c-1.1-0.4-1.8-0.8-2.3-1.2c-0.5-0.4-0.7-1-0.7-1.7 c0-0.6,0.2-1.2,0.7-1.7c0.5-0.5,1.1-0.8,2-1V5.4h1v1.2c0.5,0,1,0.2,1.5,0.5c0.5,0.3,0.8,0.7,1,1.2l-0.9,0.3 c-0.2-0.4-0.5-0.7-0.8-0.9c-0.3-0.2-0.8-0.3-1.3-0.3c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.3-0.6,0.8-0.6,1.3s0.2,0.9,0.5,1.2 c0.3,0.3,1,0.6,2.1,1c1.2,0.4,2,0.9,2.4,1.4c0.4,0.5,0.6,1.1,0.6,1.8c0,0.5-0.1,0.9-0.3,1.2c-0.2,0.4-0.4,0.6-0.7,0.9 c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.1-0.7,0.2-1.1,0.2v1.2H11.5z M2,11.5c0.1-1.4,0.4-2.7,1-3.8c0.6-1.2,1.3-2.2,2.2-3s1.9-1.5,3.1-2 S10.7,2,12,2c2,0,3.8,0.5,5.5,1.6s2.9,2.6,3.6,4.4V4.7h1v5h-5v-1h3.2c-0.6-1.7-1.7-3-3.2-4.1C15.6,3.5,13.9,3,12,3 c-1.1,0-2.2,0.2-3.3,0.6c-1,0.4-2,1-2.8,1.7C5.1,6.1,4.4,7,3.9,8c-0.5,1-0.8,2.2-0.9,3.5H2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/transactions-icon.0185a7ce25d7f7cc1e0cfda4790be5a3.svg";
export { ForwardRef as ReactComponent };